var isWindow = exports.isWindow = function (o) {
    return o != null && o == o.window;
};

var hasOwn = Object.prototype.hasOwnProperty;
var iteratesOwnLast;
(function () {
    var props = [];

    function Ctor() {
        this.x = 1;
    }

    Ctor.prototype = { 'valueOf': 1, 'y': 1 };
    for (var prop in new Ctor()) {
        props.push(prop);
    }
    iteratesOwnLast = props[0] !== 'x';
}());

/**
 * 判断是否是纯洁的对象
 * @type {isPlainObject}
 */
var isPlainObject = exports.isPlainObject = function (o) {
    // Must be an Object.
    // Because of IE, we also have to check the presence of the constructor
    // property. Make sure that DOM nodes and window objects don't
    // pass through, as well
    if (!o || toString.call(o) !== "[object Object]" ||
        o.nodeType || isWindow(o)) {
        return false;
    }

    try {
        // Not own constructor property must be Object
        if (o.constructor && !hasOwn.call(o, "constructor") && !hasOwn.call(o.constructor.prototype, "isPrototypeOf")) {
            return false;
        }
    } catch (e) {
        // IE8,9 Will throw exceptions on certain host objects #9897
        return false;
    }

    var key;

    // Support: IE<9
    // Handle iteration over inherited properties before own properties.
    // http://bugs.jquery.com/ticket/12199
    if (iteratesOwnLast) {
        for (key in o) {
            return hasOwn.call(o, key);
        }
    }

    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    for (key in o) {
    }

    return key === undefined || hasOwn.call(o, key);
}

/**
 * 判断是否是空的对象
 *
 * @type {isEmptyObject}
 */
var isEmptyObject = exports.isEmptyObject = function (o) {
    if (!o || toString.call(o) !== "[object Object]" ||
        o.nodeType || isWindow(o) || !o.hasOwnProperty) {
        return false;
    }

    for (var p in o) {
        if (o.hasOwnProperty(p)) return false;
    }
    return true;
}


var toString = Object.prototype.toString;

/**
 * 判断是否是函数
 * @method isFunction
 */
/**
 * 判断是否是字符串
 * @method isString
 */
/**
 * 判断是否是数字
 * @method isNumber
 */
/**
 * 判断是否是日期
 * @method isDate
 */
/**
 * 判断是否是正则
 * @method isRegExp
 */
/**
 * 判断是否是数组
 * @method isArray
 */

['Function', 'String', 'Number', 'Date', 'RegExp', 'Array'].forEach(function (type) {
    exports['is' + type] = function (val) {
        return toString.call(val) === '[object ' + type + ']';
    }
});

